import { useHouseholdInsightsData } from '../../data/hooks/useHouseholdInsightsData.ts';
import { parseHouseholdProfile } from '../../data/parsers/parseHouseholdProfile.ts';
import { InsightsMetricList } from '../InsightsMetricList/InsightsMetricList.tsx';

export const HouseholdProfile = () => {
  const { data, isLoading } = useHouseholdInsightsData(parseHouseholdProfile);

  return <InsightsMetricList title="Household Profile" unitLabel="households" items={data} isLoading={isLoading} />;
};
